/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deep_Match_Positioning_StrategyInputs */

const en_deep_match_positioning_strategy = /** @type {(inputs: Deep_Match_Positioning_StrategyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Positioning Strategy`)
};

const de_deep_match_positioning_strategy = /** @type {(inputs: Deep_Match_Positioning_StrategyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Positioning Strategy`)
};

const fr_deep_match_positioning_strategy = /** @type {(inputs: Deep_Match_Positioning_StrategyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Positioning Strategy`)
};

const es_deep_match_positioning_strategy = /** @type {(inputs: Deep_Match_Positioning_StrategyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Positioning Strategy`)
};

const it_deep_match_positioning_strategy = /** @type {(inputs: Deep_Match_Positioning_StrategyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Positioning Strategy`)
};

const nl_deep_match_positioning_strategy = /** @type {(inputs: Deep_Match_Positioning_StrategyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Positioning Strategy`)
};

const pl_deep_match_positioning_strategy = /** @type {(inputs: Deep_Match_Positioning_StrategyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Positioning Strategy`)
};

const fi_deep_match_positioning_strategy = /** @type {(inputs: Deep_Match_Positioning_StrategyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Positioning Strategy`)
};

const da_deep_match_positioning_strategy = /** @type {(inputs: Deep_Match_Positioning_StrategyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Positioning Strategy`)
};

const sv_deep_match_positioning_strategy = /** @type {(inputs: Deep_Match_Positioning_StrategyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Positioning Strategy`)
};

/**
* | output |
* | --- |
* | "Positioning Strategy" |
*
* @param {Deep_Match_Positioning_StrategyInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const deep_match_positioning_strategy = /** @type {((inputs?: Deep_Match_Positioning_StrategyInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deep_Match_Positioning_StrategyInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_deep_match_positioning_strategy(inputs)
	if (locale === "fr") return fr_deep_match_positioning_strategy(inputs)
	if (locale === "es") return es_deep_match_positioning_strategy(inputs)
	if (locale === "it") return it_deep_match_positioning_strategy(inputs)
	if (locale === "nl") return nl_deep_match_positioning_strategy(inputs)
	if (locale === "pl") return pl_deep_match_positioning_strategy(inputs)
	if (locale === "fi") return fi_deep_match_positioning_strategy(inputs)
	if (locale === "da") return da_deep_match_positioning_strategy(inputs)
	if (locale === "sv") return sv_deep_match_positioning_strategy(inputs)
	return en_deep_match_positioning_strategy(inputs)
});